var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.557 18.6644L13.2316 0.777327C12.6331 -0.259109 11.1344 -0.259109 10.5359 0.777327L0.210467 18.6644C-0.388039 19.7008 0.361309 21 1.55832 21H22.2092C23.4062 21 24.1555 19.7008 23.557 18.6644ZM11.8984 6.28552C12.5601 6.28552 13.0954 6.83537 13.0759 7.49713L12.8813 14.2899C12.8667 14.8252 12.4287 15.2485 11.8935 15.2485C11.3582 15.2485 10.9203 14.8203 10.9057 14.2899L10.7159 7.49713C10.7013 6.83537 11.2317 6.28552 11.8984 6.28552ZM11.8838 18.5719C11.2074 18.5719 10.6575 18.0221 10.6575 17.3457C10.6575 16.6694 11.2074 16.1195 11.8838 16.1195C12.5601 16.1195 13.11 16.6694 13.11 17.3457C13.11 18.0221 12.5601 18.5719 11.8838 18.5719Z",
    fill: "#C13515"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning1);
export default __webpack_public_path__ + "static/media/warning-1.448da681.svg";
export { ForwardRef as ReactComponent };